import useCertificationCourseData from './useCertificationCourseData';

const useFullCertificationCourseData = (goalUID, fallbackData) => {
  const {
    key: certificationCourseDataSWRKey,
    mutate: revalidateCertificationCourseData
  } = useCertificationCourseData(goalUID, {
    fallbackData: fallbackData.certificationCourseData
  });
  return {
    keys: {
      certificationCourseDataSWRKey
    },
    revalidateCertificationCourseData
  };
};

export default useFullCertificationCourseData;
